import React, { forwardRef, useImperativeHandle, useRef } from "react";
import { Bar } from "react-chartjs-2";
import { get_config_3min } from "./config.js";
import { on_update_3min_callback } from "./updateCharLogic.js";

const buildData = (rt3mins = [], rt3minsLabels = []) => ({
	labels: rt3minsLabels,
	datasets: [
		{
			label: "Факт",
			data: rt3mins,
			fill: true,
			xAxisID: "x",
			tension: 0.5,
			borderColor: "#00000044",
			backgroundColor: "#00000044",
			hoverBackgroundColor: "#00000044",
			borderWidth: 0,
			categoryPercentage: 1.1,
			spanGaps: true,
		},
	],
});

// ВАЖНО: вычисляются один раз на уровне модуля, а не внутри компонента.
// Если передавать buildData()/get_config_3min(90) как JSX-литералы в <Bar>,
// они пересоздаются на КАЖДЫЙ рендер компонента — а react-chartjs-2 при
// смене ссылки на data/options сам сбрасывает chart.data/chart.options
// обратно к этим "исходным" значениям, поверх того, что только что
// императивно записали applyRealtimeUpdate/setStats через ref.
const INITIAL_DATA = buildData();
const INITIAL_OPTIONS = get_config_3min(90);

const Rt3MinChart = forwardRef(function Rt3MinChart(_props, ref) {
	const chartRef = useRef(null);

	useImperativeHandle(ref, () => ({
		applyRealtimeUpdate(data, station) {
			const chart = chartRef.current;
			if (!chart) return;
			on_update_3min_callback(chart, data, station);
			chart.update();
		},
		setStats({ rt3mins, rt3minsLabels, mid3min }) {
			const chart = chartRef.current;
			if (!chart) return;
			chart.data = buildData(rt3mins, rt3minsLabels);
			chart.options = get_config_3min(mid3min);
			chart.update();
		},
	}));

	return (
		<div
			className="chart"
			style={{
				height: "240px",
				width: "100%",
				margin: "auto",
				position: "relative",
			}}
		>
			<Bar
				style={{
					height: "240px",
					width: "100%",
					margin: "auto",
					position: "relative",
				}}
				ref={chartRef}
				data={INITIAL_DATA}
				options={INITIAL_OPTIONS}
			/>
		</div>
	);
});

// Компонент без props, полностью управляется через ref — не должен
// перерендериваться из-за родителя вообще.
export default React.memo(Rt3MinChart);
